import React from 'react'
import injectSheet from 'react-jss'
import styles from './work-with-moderator.styles'
import Button from 'pobble-components/dist/button'
import simon from './simon.jpg'

const WorkWithModerator = ({ classes }) => (
  <div className={classes.container}>
    <div className={classes.content}>
      <div className={classes.event}>
        <h3 className={classes.title}>
          Making the most of your moderation subscription
        </h3>
        <p className={classes.intro}>
          Master the Pobble online moderation tool.
        </p>
        <p className={classes.intro}>
          During the session you'll learn how to use our tools to:
          <ul>
            <li>Build your own moderation files</li>
            <li>Run effective moderation sessions</li>
            <li>Develop cross-school moderation opportunities</li>
            <li>Build your own school exemplification materials</li>
          </ul>
          Plus! You'll have a chance to try the moderation tools for yourself!
        </p>

        <Button
          className={classes.eventButton}
          href="https://us02web.zoom.us/webinar/register/3716463928139/WN_HUgqSpnWTW2Epq0N2szWXQ"
          _blank="_blank"
          rel="noopener noreferrer"
          tall>
          Book a free place
        </Button>
      </div>
    </div>

    <div className={classes.moderator}>
      <div>
        <img src={simon} alt="Simon" />
        <h4>Meet your webinar host</h4>
        <p>
          Simon is a former Primary School leader and one of the Pobble
          co-founders. He has delivered Pobble training in schools across the
          world and seen first-hand the impact Pobble can have on pupils
          writing.
        </p>
      </div>
    </div>
  </div>
)

export default injectSheet(styles)(WorkWithModerator)
